/**
 * Check if a given object implements the OfferGroupDisplayInfo interface.
 */
export function instanceOfOfferGroupDisplayInfo(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "thumbnailImageAssetId" in value;
    return isInstance;
}
export function OfferGroupDisplayInfoFromJSON(json) {
    return OfferGroupDisplayInfoFromJSONTyped(json, false);
}
export function OfferGroupDisplayInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'thumbnailImageAssetId': json['thumbnailImageAssetId'],
    };
}
export function OfferGroupDisplayInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'thumbnailImageAssetId': value.thumbnailImageAssetId,
    };
}
